export default "__VITE_ASSET__CINFHmel__"